import React from "react";
import { Oval } from "react-loader-spinner";

const MyLoader = () => {
  return (
    <>
      <style>{`
        .loader-container {
          height: 100vh;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          background: #ffffff;
        }

        .loader-text {
          margin-top: 12px;
          font-size: 14px;
          color: #666;
        }

        .loader-logo {
          height: 60px;
          margin-bottom: 20px;
        }
      `}</style>

      <div className="loader-container">
        {/* OPTION LOGO */}
        <img src="/logo.png" alt="logo" className="loader-logo" />

        <Oval
          height={70}
          width={70}
          color="#edbb05"
          visible={true}
          ariaLabel="loading"
          secondaryColor="#f3f4f6"
          strokeWidth={3}
          strokeWidthSecondary={3}
        />

        <p className="loader-text">Chargement du menu...</p>
      </div>
    </>
  );
};

export default MyLoader;